import { createSelector } from '@reduxjs/toolkit'
import { Notification } from '@repo/core'
import { RootState } from '../../store/types'

const notificationsRootSelector = (state: RootState): Notification[] => state.app.notifications

export const notificationsSelector = createSelector([notificationsRootSelector], (notifications) =>
  notifications.reduce(
    (acc: Record<string, Notification[]>, item: Notification) => {
      const key = item.level
      acc[key] = [...(acc[key] ?? []), item]
      return acc
    },
    {} as Record<string, typeof notifications>,
  ),
)
